import type { ModuleDefinition } from '../../../../app/moduleRegistry';

/** CMS İçerik: Popüler Şehirler (PopulerCity) — Master-GSA-only, gated behind `HasCmsB2C`.
 *  No longer a standalone routed page: `PopulerCityListPage` now requires a `siteId` prop and
 *  is rendered directly as a tab inside `SiteDetailPage` (see
 *  ../../site/site/pages/SiteDetailPage.tsx), so this sub-module contributes no route/menu
 *  item of its own — kept only so the sibling `cms/content` aggregator's import shape stays
 *  uniform. */
export const populerCityModule: ModuleDefinition = {
  routes: [],
  menuItems: [],
};
